import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import DotIndicator from '@wix/da-ds/pkg/Indicators/DotIndicator';
import s from './WatchButton.scss';
const WatchButton = ({ className, watchCount })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['button-wrapper']
    }, watchCount > 0 && /*#__PURE__*/ React.createElement(DotIndicator, {
        className: s['dot']
    }), /*#__PURE__*/ React.createElement(TextButton, {
        size: "medium",
        variant: "main",
        className: className,
        biData: BiData({
            evid: 700,
            link_url: Url.watchLink(),
            link_name: 'watch',
            indicator: watchCount > 0 ? 1 : 0
        }),
        href: Url.watchLink()
    }, t('siteHeader.watch')));
};
WatchButton.displayName = 'WatchButton';
export default WatchButton;
